import { Group, Title, Grid } from "@mantine/core"

import { RoleTemplate } from "../Components/RoleTemplate"
import { AzureADRoles } from "../Auth/auth-roles"

import { AssignedToMeWorkOrderList } from "../Components/Home/AssignedToMeWorkOrderList"
import { AssignedToTeamWorkOrderList } from "../Components/Home/AssignedToTeamWorkOrderList"
import { RequestedByMeWorkOrderList } from "../Components/Home/RequestedByMeWorkOrderList"
import { RequestedByTeamWorkOrderList } from "../Components/Home/RequestedByTeamWorkOrderList"

const Home = () => {
	return <>
		<Group justify="space-between">
			<Title order={2}>Home</Title>
		</Group>

		<Grid mb="xl" mt="sm" gutter="xl">
			<RoleTemplate role={AzureADRoles.Requester} exact={true}>
				<Grid.Col span={{ sm:6 }}>
					<RequestedByMeWorkOrderList />
				</Grid.Col>
				<Grid.Col span={{ sm:6 }}>
					<RequestedByTeamWorkOrderList />
				</Grid.Col>
			</RoleTemplate>

			<RoleTemplate role={AzureADRoles.AdminOrFullUser}>
				<Grid.Col span={{ sm:6 }}>
					<AssignedToMeWorkOrderList />
				</Grid.Col>
				<Grid.Col span={{ sm:6 }}>
					<AssignedToTeamWorkOrderList />
				</Grid.Col>
			</RoleTemplate>
		</Grid>
	</>
}

export default Home